export default "__VITE_ASSET__kgrXDjYg__"